var map = {
	"./404.svg": 75917,
	"./auth.svg": 42261,
	"./baseinfo.svg": 18108,
	"./batchout.svg": 14127,
	"./bind.svg": 49202,
	"./biztype.svg": 10622,
	"./car.svg": 29011,
	"./computer.svg": 19200,
	"./customer.svg": 90779,
	"./dc.svg": 51736,
	"./dc2.svg": 80474,
	"./dcin.svg": 2629,
	"./dcout.svg": 33084,
	"./defication.svg": 71619,
	"./department.svg": 69597,
	"./device.svg": 73769,
	"./devicemanage.svg": 86812,
	"./dic.svg": 25869,
	"./earth.svg": 8973,
	"./encode.svg": 96925,
	"./encodec.svg": 38404,
	"./group.svg": 21684,
	"./home.svg": 62818,
	"./internet.svg": 14356,
	"./inventory.svg": 79733,
	"./language.svg": 72097,
	"./lock.svg": 7894,
	"./mdpd.svg": 93904,
	"./mdth.svg": 48736,
	"./offline.svg": 42304,
	"./online.svg": 82974,
	"./orderdef.svg": 23130,
	"./orderitemdef.svg": 26061,
	"./ordertype.svg": 5045,
	"./otherin.svg": 52514,
	"./producein.svg": 53820,
	"./products.svg": 27903,
	"./productspic.svg": 64097,
	"./purchasein.svg": 45567,
	"./readerdriver.svg": 65888,
	"./retail.svg": 48870,
	"./retailin.svg": 55407,
	"./retailreturn.svg": 28676,
	"./return.svg": 98821,
	"./role.svg": 61499,
	"./saleout.svg": 47318,
	"./sales.svg": 52621,
	"./salesreturn.svg": 65271,
	"./sellout.svg": 15509,
	"./sellreturn.svg": 87269,
	"./settings.svg": 18768,
	"./shopin.svg": 71406,
	"./shopreturn.svg": 31017,
	"./user.svg": 66518,
	"./vendor.svg": 6809,
	"./version.svg": 74605,
	"./warehouse.svg": 88156
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;